class Search {
  constructor() {
    this.initialize()
  }

  initialize() {
    this.bindUI()
    this.bindEvents()
  }

  bindUI() {
    this.searches = document.querySelectorAll('.js-search')
    this.searchItems = document.querySelectorAll('.js-search-item')
  }

  bindEvents() {
    for (let i = 0; i < this.searches.length; i++) {
      let input = this.searches[i].querySelector('.js-search-input')
      input.addEventListener('keyup', this.onKeyUp.bind(this))
    }
  }

  onKeyUp(e) {
    // Ignorer Tab et Shift + Tab
    if (e.key === 'Tab') return;

    let target = e.target;
    let filter = target.value.toUpperCase();

    for (let i = 0; i < this.searchItems.length; i++) {
        let a = this.searchItems[i].getElementsByTagName('button')[0];
        let txtValue = a.textContent || a.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
            this.searchItems[i].classList.remove('u-is-hidden');
        } else {
            this.searchItems[i].classList.add('u-is-hidden');
        }
    }
}

}

export default Search
